import { t } from '@/plugins/i18n'

export const additionSetColumns = [
  {
    label: t('组合名称'),
    align: 'center',
    prop: 'templateName',
    slotName: 'templateName'
  },
  {
    label: t('附加项数量'),
    align: 'center',
    prop: 'additionNum'
  },
  {
    label: t('附加项'),
    align: 'center',
    prop: 'additionName',
    slotName: 'additionName'
  },
  {
    label: t('类型'),
    align: 'center',
    prop: 'templateType',
    slotName: 'templateType'
  },
  {
    label: t('备注'),
    align: 'center',
    prop: 'remark'
  },
  {
    label: t('状态'),
    align: 'center',
    prop: 'templateStatus',
    slotName: 'templateStatus'
  }
]

export const tableConfig = {
  showHandler: true,
  setHeight: true
}
